import { AnalyticsProviderUser } from "@storefront-core/analytics-web";

const SEARCH_ANALYTICS_HANDOFF_COOKIE = 'sf_search_analytics_handoff';
const WEB_COMMON_PROPS_COOKIE_NAME = "makro_web_common_props";
export const USER_INFO_COOKIE = "sf_user_info";
const readCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'
    )
  );
  return match ? match[1] : null;
};

export const getSearchAnalyticsHandoff = (): unknown | null => {
  if (typeof document === 'undefined') return null;

  const raw = readCookie(SEARCH_ANALYTICS_HANDOFF_COOKIE);
  if (!raw) return null;

  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
};

export const getCommonAnalyticsProperties = (): unknown | null => {
  if (typeof document === 'undefined') return null;

  const raw = readCookie(WEB_COMMON_PROPS_COOKIE_NAME);
  if (!raw) return null;

  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
};

export const getPageNameFromCookies = (): string => {
  const cookie = getSearchAnalyticsHandoff() as { originPage?: string } | null;
  return cookie?.originPage || "";
};

export const getUserInfo = (): AnalyticsProviderUser | null => {
  if (typeof document === 'undefined') return null;

  const raw = readCookie(USER_INFO_COOKIE);
  if (!raw) return null;

  try {
    const userObject = JSON.parse(decodeURIComponent(raw));
    return {
      id : userObject.userId,
      email: userObject.email,
      name: userObject.name,
      phone: userObject.phone
    }
  } catch {
    return null;
  }
};